import Bank from '@/services/bank'

const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Bank.fetch().then((response) => {
      commit('SET_LIST', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const FindBanksByAssignor = async (context, id) => {
  return new Promise((resolve, reject) => {
    Bank.fetchByAssignor().then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  fetch,
  FindBanksByAssignor
}



// WEBPACK FOOTER //
// ./src/features/banks/store/actions.js